// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[type=number][data-v-f408a252]::-webkit-inner-spin-button,input[type=number][data-v-f408a252]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.custom-number-input button[data-v-f408a252]:focus,.custom-number-input input[data-v-f408a252]:focus{outline:none!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
